import React, {ReactNode} from 'react';

import {Header} from './components';
import styles from './Workspace.module.scss';
import {useLocation} from 'react-router';
import pageTitles from '../../../../pageTitles';
import {SearchBar} from './components/Header/components';

export interface Props {
  pageMarkup: ReactNode;
}

export default function Workspace({pageMarkup}: Props) {
  const location = useLocation();
  const pageTitle = pageTitles[location.pathname];
  // TODO: Better way to get search page title
  const headerMarkup = pageTitle && (
    <Header>
      <h1 className={styles.Title}>{pageTitle || 'Search'}</h1>
    </Header>
  );

  return (
    <div className={styles.Workspace}>
      <div className={styles.HeaderSpace} />
      {headerMarkup}
      <SearchBar />
      <div className={styles.HeaderSpace} />
      <div className={styles.PageWrapper}>{pageMarkup}</div>
    </div>
  );
}
